import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    updateCartLineWithResult as updateCartLineApi,
} from "@insite/client-framework/Services/CartService";
import  { chain,DispatchBeginUpdateCartLine, UpdateCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/UpdateCartLine";

type UpdateCartLineProps = Parameters<typeof DispatchBeginUpdateCartLine>[0];

async function CustomUpdateCartLine(props: UpdateCartLineProps)  {
    delete props.apiParameter.cartLine.properties["messages"];
    delete props.apiParameter.cartLine.properties["warehouses"];
    await updateCartLineApi(props.apiParameter);
}
replaceInChain(
    chain,
    UpdateCartLine,
    CustomUpdateCartLine
);